import { createContext, useContext } from "react";
import { CallFlowActionType } from "@/model/interface/CallFlowActionType";
import { FlowOrientation } from "@/model/interface/CallFlow";

export interface FlowBuilderActions {
  orientation: FlowOrientation;
  deleteNode: (nodeId: string) => void;
  chooseActionType: (nodeId: string, actionType: CallFlowActionType) => void;
  addLinkedNode: (sourceId: string, sourceHandle?: string) => void;
}

export const FlowBuilderContext = createContext<FlowBuilderActions | null>(null);

export function useFlowBuilder(): FlowBuilderActions {
  const context = useContext(FlowBuilderContext);
  if (!context) {
    throw new Error("useFlowBuilder must be used inside FlowBuilder");
  }
  return context;
}
